import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen wo-bg flex items-center justify-center px-5">
      <div className="liquid-glass rounded-2xl p-10 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={56} className="mx-auto text-slate-400 mb-4" />
        <h1 className="font-display font-bold text-2xl text-slate-100">Checkout cancelled</h1>
        <p className="text-slate-400 text-sm mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/upgrade"><Button className="mt-6 bg-gradient-to-r from-teal-400 to-cyan-500 text-slate-900 font-semibold">Back to plans</Button></Link>
      </div>
    </div>
  );
}
